import {
  ALL_CERTIFICATE_TYPES,
  categoryForRequestType,
  type NewRequestSelectableType,
  type RequestCategory,
} from "@/components/features/notarial-requests/new-notarial-request-types";
import {
  catalogItemForType,
  type CertificatePricingCatalogItem,
} from "@/services/certificatePricingCatalogService";

export type CertificateProductFlowKind =
  | "legal_entity_notary"
  | "income_accountant"
  | "simple_notary"
  | "simple_accountant";

export function categoryForCatalogProductType(
  type: string,
  catalog: CertificatePricingCatalogItem[] | undefined
): RequestCategory {
  if (type === "income_certificate") {
    return "accountant";
  }
  if (type === "notarial_legal_entity") {
    return "notary";
  }
  const row = catalogItemForType(catalog ?? [], type);
  if (row) {
    if (row.involvesAccountant && !row.involvesNotary) {
      return "accountant";
    }
    if (row.involvesNotary && !row.involvesAccountant) {
      return "notary";
    }
    if (row.involvesNotary) {
      return "notary";
    }
    return "accountant";
  }
  if (ALL_CERTIFICATE_TYPES.includes(type as NewRequestSelectableType)) {
    return categoryForRequestType(type as NewRequestSelectableType);
  }
  return "notary";
}

export function flowKindForProductType(
  type: string,
  catalog: CertificatePricingCatalogItem[] | undefined
): CertificateProductFlowKind {
  if (type === "notarial_legal_entity") {
    return "legal_entity_notary";
  }
  if (type === "income_certificate") {
    return "income_accountant";
  }
  const row = catalogItemForType(catalog ?? [], type);
  if (row) {
    if (row.involvesAccountant && !row.involvesNotary) {
      return "simple_accountant";
    }
    if (!row.involvesAccountant && row.involvesNotary) {
      return "simple_notary";
    }
    if (row.involvesNotary) {
      return "simple_notary";
    }
    return "simple_accountant";
  }
  if (ALL_CERTIFICATE_TYPES.includes(type as NewRequestSelectableType)) {
    return categoryForRequestType(type as NewRequestSelectableType) === "accountant"
      ? "income_accountant"
      : "simple_notary";
  }
  return "simple_notary";
}
